import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0fc1e53c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ss-calendario-eventos-header" }
const _hoisted_2 = { class: "ss-calendario-eventos-navegacao" }
const _hoisted_3 = {
  tabindex: "0",
  class: "ant-picker-panel"
}
const _hoisted_4 = { class: "ant-picker-date-panel" }
const _hoisted_5 = {
  class: "ant-picker-body",
  style: {"padding":"0px"}
}
const _hoisted_6 = { class: "ant-picker-content" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Dom"),
    /*#__PURE__*/_createElementVNode("th", null, "Seg"),
    /*#__PURE__*/_createElementVNode("th", null, "Ter"),
    /*#__PURE__*/_createElementVNode("th", null, "Qua"),
    /*#__PURE__*/_createElementVNode("th", null, "Qui"),
    /*#__PURE__*/_createElementVNode("th", null, "Sex"),
    /*#__PURE__*/_createElementVNode("th", null, "Sáb")
  ])
], -1))
const _hoisted_8 = {
  key: 0,
  title: "",
  class: "ant-picker-cell ant-picker-cell-disabled ant-picker-cell-end"
}
const _hoisted_9 = ["title", "onClick"]
const _hoisted_10 = { class: "ant-row ss-div-hoje" }
const _hoisted_11 = { class: "ss-span-dia" }
const _hoisted_12 = { class: "ant-row ss-div-evento" }
const _hoisted_13 = ["title", "onClick"]
const _hoisted_14 = { class: "ant-picker-calendar-date-value" }
const _hoisted_15 = { class: "ant-row ss-div-dia" }
const _hoisted_16 = { class: "ss-span-dia" }
const _hoisted_17 = { class: "ant-row ss-div-evento" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_a_tooltip, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.calendarioMesAnterior())),
        placement: "top",
        title: "Mês anterior"
      }, {
        default: _withCtx(() => [
          _createElementVNode("a", _hoisted_2, [
            _createVNode(_component_icone, { nome: "navegacao-anterior" })
          ])
        ]),
        _: 1
      }),
      _createTextVNode(" " + _toDisplayString(_ctx.obterMesAnoCalendario()) + " ", 1),
      _createVNode(_component_a_tooltip, {
        placement: "top",
        title: "Próximo mês"
      }, {
        default: _withCtx(() => [
          _createElementVNode("a", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.calendarioProximoMes())),
            class: "ss-calendario-eventos-navegacao"
          }, [
            _createVNode(_component_icone, { nome: "navegacao-proximo" })
          ])
        ]),
        _: 1
      })
    ]),
    (_openBlock(), _createElementBlock("div", {
      key: _ctx.props.dataCalendario,
      class: "ant-picker-calendar ant-picker-calendar-full"
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("table", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.semanas, (semana, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(semana, (dia) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: dia }, [
                        (dia == '')
                          ? (_openBlock(), _createElementBlock("td", _hoisted_8, [
                              _createElementVNode("div", {
                                class: "ant-picker-cell-inner ant-picker-calendar-date",
                                style: _normalizeStyle(_ctx.state.alturaDias)
                              }, null, 4)
                            ]))
                          : (_ctx.UtilitarioData.aplicaFormatoData(_ctx.props.dataCalendario) == _ctx.UtilitarioData.aplicaFormatoData(dia))
                            ? (_openBlock(), _createElementBlock("td", {
                                key: 1,
                                title: _ctx.UtilitarioData.aplicaFormatoData(dia),
                                class: "ant-picker-cell ant-picker-cell-in-view ant-picker-cell-today ant-picker-cell-selected",
                                onClick: ($event: any) => (_ctx.clickDia(dia))
                              }, [
                                _createElementVNode("div", {
                                  class: "ant-picker-cell-inner ant-picker-calendar-date ant-picker-calendar-date-today",
                                  style: _normalizeStyle(_ctx.state.classeDias)
                                }, [
                                  _createElementVNode("div", _hoisted_10, [
                                    _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.UtilitarioData.obterDiaData(dia)), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_12, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.props.eventos, (evento) => {
                                      return (_openBlock(), _createElementBlock(_Fragment, { key: evento }, [
                                        (evento.data === dia)
                                          ? (_openBlock(), _createBlock(_component_a_tooltip, {
                                              key: 0,
                                              placement: "top",
                                              title: evento.titulo,
                                              color: evento.cor
                                            }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("span", {
                                                  class: "ant-badge-status-dot ss-span-status",
                                                  style: _normalizeStyle('background-color: ' + evento.cor)
                                                }, null, 4)
                                              ]),
                                              _: 2
                                            }, 1032, ["title", "color"]))
                                          : _createCommentVNode("", true)
                                      ], 64))
                                    }), 128))
                                  ])
                                ], 4)
                              ], 8, _hoisted_9))
                            : (_openBlock(), _createElementBlock("td", {
                                key: 2,
                                title: _ctx.UtilitarioData.aplicaFormatoData(dia),
                                class: "ant-picker-cell ant-picker-cell-start ant-picker-cell-in-view",
                                onClick: ($event: any) => (_ctx.clickDia(dia))
                              }, [
                                _createElementVNode("div", {
                                  class: "ant-picker-cell-inner ant-picker-calendar-date",
                                  style: _normalizeStyle(_ctx.state.classeDias)
                                }, [
                                  _createElementVNode("div", _hoisted_14, [
                                    _createElementVNode("div", _hoisted_15, [
                                      _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.UtilitarioData.obterDiaData(dia)), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_17, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.props.eventos, (evento) => {
                                        return (_openBlock(), _createElementBlock(_Fragment, { key: evento }, [
                                          (evento.data === dia)
                                            ? (_openBlock(), _createBlock(_component_a_tooltip, {
                                                key: 0,
                                                placement: "top",
                                                title: evento.titulo,
                                                color: evento.cor
                                              }, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("span", {
                                                    class: "ant-badge-status-dot ss-span-status",
                                                    style: _normalizeStyle('background-color: ' + evento.cor)
                                                  }, null, 4)
                                                ]),
                                                _: 2
                                              }, 1032, ["title", "color"]))
                                            : _createCommentVNode("", true)
                                        ], 64))
                                      }), 128))
                                    ])
                                  ])
                                ], 4)
                              ], 8, _hoisted_13))
                      ], 64))
                    }), 128))
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ]))
  ]))
}